import Vue from 'vue';
import Vuex from 'vuex';
import { userService } from '@/api/user';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        titlePortal: '', 
        userData: null, 
    },
    mutations: {
        setTitle(state, title) {
            state.titlePortal = title; 
        },
        setUserData(state, data) { 
            state.userData = data;
        },
    },
    actions: {
        async fetchUserData({ commit }) { 
            const data = await userService.userData();
            commit('setUserData', data); 
        },
    },
    getters: {
        getUserData(state) { 
            return state.userData;
        },
    },
});
